<template>
  <vue-excel-xlsx
    :data="datas"
    :columns="columns"
    :filename="$store.getters.storeInfo.storeName + '-' + filename"
    :sheetname="$store.getters.storeInfo.storeName"
  >
    <v-btn icon x-large>
      <v-icon large color="success" v-text="'mdi-file-excel'" />
    </v-btn>
    <p class="title" v-text="'Export'" />
  </vue-excel-xlsx>
</template>

<script>
export default {
  name: "ExcelExport",
  props: {
    datas: {
      type: Array,
      required: true,
    },
    columns: {
      type: Array,
      required: true,
    },
    filename: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    json_meta: [
      [
        {
          key: "charset",
          value: "utf-8",
        },
      ],
    ],
  }),
};
</script>
<style lang="scss" scoped>
.title {
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  padding: 0 !important;
  line-height: 0px !important;
}
</style>
